import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  GET,
  GET_ACTION_MENU,
  GET_ACTION_MENU_EMP_ENGAGEMENT,
  GET_ACTION_MENU_EMP_ENGAGEMENT_URL,
  GET_ACTION_MENU_URL,
  REVIEW_WBT_ATTEMPT,
  REVIEW_WBT_ATTEMPT_URL,
  PUT,
} from "../../Api";
import apiRequest from "../../Api/connector";
import { STATUS_200 } from "../../Api/constants";
import { SomethingWentWrong } from "../../utils/Constant";
import { showToast } from "../../utils/helper/helper";

const initialState = {
  actionMenu: {
    data: {
      nomination_request: [],
      review_pending_skill_submissions: [],
      self_assessment_review: [],
      course_session_assignment: [],
      standalone_assessment_review: [],
      pending_skill_assignments: [],
      course_feedback: [],
      module_feedback: [],
      training_schedules: [],
      training_feedback_30_days: [],
      training_feedback_60_days: [],
      training_feedback_90_days: [],
      wbt_attempts: [],
    },
  },
  actionMenuOnboarding: {
    data: {
      onboarding: [],
      employee_data_change: [],
      valid_till_users: [],
    },
  },
  loading: false,
  error: null,
};

export const getActionMenuData = createAsyncThunk(GET_ACTION_MENU, async () => {
  const response = await apiRequest(GET, GET_ACTION_MENU_URL());
  return response;
});

export const getActionMenuOnboardingData = createAsyncThunk(
  GET_ACTION_MENU_EMP_ENGAGEMENT,
  async () => {
    const response = await apiRequest(
      GET,
      GET_ACTION_MENU_EMP_ENGAGEMENT_URL()
    );
    return response;
  }
);

export const reviewWbtAttempt = createAsyncThunk(
  REVIEW_WBT_ATTEMPT,
  async (payload: { payload: any }) => {
    const response = await apiRequest(
      PUT,
      REVIEW_WBT_ATTEMPT_URL(),
      payload?.payload
    );
    return response;
  }
);

const ActionMenuSlice = createSlice({
  name: "actionMenu",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getActionMenuData.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActionMenuData.fulfilled, (state, action) => {
        state.loading = false;
        state.actionMenu = action.payload;
      })
      .addCase(getActionMenuData.rejected, (state, action) => {
        try {
          const error = JSON.parse(action.error.message);
          state.error = error.message;
          showToast(state?.error, "error");
        } catch (e) {
          state.error = SomethingWentWrong;
        }
      });

    builder
      .addCase(getActionMenuOnboardingData.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActionMenuOnboardingData.fulfilled, (state, action) => {
        state.loading = false;
        state.actionMenuOnboarding = action.payload;
      })
      .addCase(getActionMenuOnboardingData.rejected, (state, action) => {
        try {
          const error = JSON.parse(action.error.message);
          state.error = error.message;
          showToast(state?.error, "error");
        } catch (e) {
          state.error = SomethingWentWrong;
        }
      });

    builder
      .addCase(reviewWbtAttempt.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reviewWbtAttempt.fulfilled, (state, action) => {
        state.loading = false;
        const { status_code, message } = action.payload;
        if (status_code === STATUS_200) showToast(message, "success");
      })
      .addCase(reviewWbtAttempt.rejected, (state, action) => {
        try {
          const error = JSON.parse(action.error.message);
          state.error = error.message;
          showToast(state?.error, "error");
        } catch (e) {
          state.error = SomethingWentWrong;
        }
      });
  },
});

export default ActionMenuSlice.reducer;
